<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Press Release Schedule</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:pr-4">
                        <div class="account-body">
                            <form>
                                <div class="form-field styled" v-if="mediaLists">
                                    <Listbox as="div" v-model="scheduleData.destination">
                                        <ListboxLabel class="block text-sm font-medium text-gray-700">Destination</ListboxLabel>
                                        <div class="mt-1 relative">
                                            <ListboxButton class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                                <span class="block truncate" v-if="scheduleData.destination">
                                                    {{ scheduleData.destination.title }}
                                                </span>
                                                <span class="block truncate" v-else>Choose a destination</span>
                                                <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                                  <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                </span>
                                            </ListboxButton>

                                            <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                                                <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                                    <ListboxOption as="template" v-for="list in mediaLists" :key="list.title" :value="list" v-slot="{ active, selected }">
                                                        <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9']">
                                                              <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                                                                {{ list.title }}
                                                              </span>
                                                              <span v-if="selected" :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                                                                  <CheckIcon class="h-5 w-5" aria-hidden="true" />
                                                              </span>
                                                        </li>
                                                    </ListboxOption>
                                                </ListboxOptions>
                                            </transition>
                                        </div>
                                    </Listbox>
                                </div>

                                <div class="form-field styled">
                                    <label class="text-sm">Release Date</label>

                                    <simple-date-time-picker
                                        v-model="scheduleData.release">
                                    </simple-date-time-picker>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 md:pl-4">

                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>

            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>

import {CheckIcon, ChevronUpDownIcon} from "@heroicons/vue/24/outline";
import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from "@headlessui/vue";

export default {
    name: "PressReleaseScheduleView",
    props: {
        schedule: {
            required: true,
        }
    },
    components: {
        CheckIcon,
        ChevronUpDownIcon,
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOptions,
        ListboxOption,
    },
    data() {
        return {
            scheduleData: {},
            mediaLists: [],
        }
    },
    mounted() {
        this.setMetaTitle('View Schedule | JournoLink Control')
        this.loadData();

        window.addEventListener('keyup', this.handleKeypress)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeypress)
    },
    methods: {
        loadData() {
            axios.get(route('releases.schedule.lists', [this.$route.params.releaseId]))
                .then((response) => {
                    this.mediaLists = response.data
                })
        },
        saveForm() {
            axios.post(route('releases.schedule.new', [this.$route.params.releaseId]), this.scheduleData)
                .then(response => {
                    this.$bus.$emit('alert.success', 'Create Success')
                    this.closeView()
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Create Failed')
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
    }
}
</script>

<style lang="less">
.vdp-datepicker {
    display: inline-block;
    border: 1px solid #dddddd;
    padding: 5px;
}

.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
